export const LANGUAGES = ['th', 'en', 'zh', 'kr', 'jp'] as const
export type Language = typeof LANGUAGES[number]

export const SWITCH_LANGUAGE_LABELS: Record<Language, string> = {
    th: 'ภาษา',
    en: 'Language',
    zh: '语言',
    kr: '언어',
    jp: '言語',
}
